import Modal from "react-modal";
import { AiOutlineClose, AiOutlineWarning } from "react-icons/ai";
import { IconContext } from "react-icons";
import styled from "styled-components";
import { CustomButton } from "../customButton";
import { useState } from "react";
import moment from "moment";

interface SendToBossModalProps {
  open: boolean;
  handleClose: () => void;
  onConfirm: () => void;
  loading?: boolean;
  body?: string | JSX.Element;
  pendingPayslipsCount?: number;
  finalisedPayslipsCount?: number;
  payrunDate?: string;
}

const customStyles = {
  content: {
    top: "45%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    border: "1px solid #eee",
    borderRadius: "10px",
    maxWidth: "500px",
    padding: 0,
  },
  overlay: {
    zIndex: 100,
    backgroundColor: "rgba(0,0,0,0.5)",
  },
};

const SendToBossModal = (props: SendToBossModalProps) => {
  const {
    handleClose,
    open,
    onConfirm,
    pendingPayslipsCount = 0,
    payrunDate,
  } = props;
  const [isConfirmed, setIsConfirmed] = useState(true);

  console.log("pendingPayslipsCount", pendingPayslipsCount);
  return (
    <Modal
      isOpen={open}
      onRequestClose={()=>{
        handleClose();
        setIsConfirmed(false);
      }}
      style={customStyles}
      contentLabel="Send to TellBoss"
      ariaHideApp={false}
    >
      <div>
        <Header>
          <h3>{`Create Payrun Monthly: ${moment(
            payrunDate,
            "YYYY-MM-DD"
          ).format("DD-MM-YYYY")}`}</h3>
          <span onClick={()=>{
            handleClose();
            setIsConfirmed(false);
          }}>
            <IconContext.Provider value={{ color: "red", size: "20px" }}>
              <AiOutlineClose />
            </IconContext.Provider>
          </span>
        </Header>
        <Body>
            <WarningContainer style={pendingPayslipsCount === 0 ? { borderColor: '#cce5ff', backgroundColor: '#f8f9ff', color: '#004085', padding: '1rem', } : undefined}>
            <WarningText>
              {pendingPayslipsCount > 0
              ? `${pendingPayslipsCount > 1 ? "There are" : "There is"} ${
                pendingPayslipsCount || 0
                } pending ${
                pendingPayslipsCount > 1 ? "payslips" : "payslip"
                } that will be excluded from this
              payrun. If you confirm you will need to create another payrun
              later after finalising ${
              pendingPayslipsCount > 1 ? "them" : "it"
              }.`
              : "Are you sure you want to send to Tellboss for approval?"}
            </WarningText>
            </WarningContainer>

          {pendingPayslipsCount > 0 && (
            <CheckboxContainer>
              <Checkbox
                type="checkbox"
                checked={isConfirmed}
                onChange={(e) => setIsConfirmed(e.target.checked)}
              />
              <CheckboxLabel>
                Continue without the pending payslips?
              </CheckboxLabel>
            </CheckboxContainer>
          )}
          
        </Body>
        <Footer>
          <CustomButton
            title="Create and send to TellBoss"
            onClick={onConfirm}
            disable={pendingPayslipsCount > 0 ? !isConfirmed : false}
            styles={{ opacity: pendingPayslipsCount > 0 ? (!isConfirmed ? 0.5 : 1) : 1 }}
          />
          <CustomButton title="Cancel" type="secondary" onClick={()=>{
            handleClose();
            setIsConfirmed(false);
          }} />
        </Footer>
      </div>
    </Modal>
  );
};

export default SendToBossModal;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #059bbf;
  padding: 10px 20px 20px 20px;
  h3 {
    color: #059bbf;
  }
  span {
    cursor: pointer;
  }
`;

const Body = styled.div`
  padding: 40px;
`;

const Footer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  background-color: #f5f5f5;
  padding: 14px 15px 15px;
  border-top: 1px solid #059bbf;
`;

const WarningContainer = styled.div`
  display: flex;
  border-radius: 8px;
  border: 1px solid #ffeeba;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 20px;
  color: #856404;
  background-color: #fff3cd;
  padding: 16px;
`;

const WarningText = styled.p`
  margin-bottom: 0px;
  line-height: 1.5;
  /* padding: 8px; */
  border-radius: 4px;
  font-size: 1rem;
  font-weight: 500;
`;

const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  /* margin-top: 20px; */
`;

const Checkbox = styled.input`
  width: 18px;
  height: 18px;
  cursor: pointer;
  appearance: none;
  border: 2px solid #757575;
  border-radius: 3px;
  position: relative;
  transition: all 0.2s ease;

  &:checked {
    background-color: #059bbf;
    border-color: #059bbf;
  }

  &:checked::after {
    content: "";
    position: absolute;
    left: 5px;
    top: 1px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
  }

  &:hover {
    border-color: #059bbf;
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(5, 155, 191, 0.2);
  }
`;

const CheckboxLabel = styled.label`
  color: #ff6665;
  font-weight: 600;
  padding: 0;
  /* cursor: pointer; */
`;
